import React, { PureComponent } from "react";
import PropTypes from "prop-types";

// Utils
import { FormattedNumber } from "react-intl";

// Actions
import { fetchCampaignStats } from "data/campaigns/actions";

import SearchForm from "./SearchForm";
import renderStatType from "../renderStatType";
import { connect } from "react-redux";
import { getEntity } from "data/entity";

class MenuBarStatsLive extends PureComponent {
  constructor(props, context) {
    super(props);
    this.state = {
      stats: null,
    };
  }

  componentWillMount() {
    const { pollingInterval } = this.props;

    this.storeInitialStats();

    // If we are polling and polling_interval isn't 0
    if (pollingInterval && typeof pollingInterval == "number") {
      this.intervalLength = pollingInterval;
      this.pollStats();
      setTimeout(() => {
        this.interval = setInterval(() => {
          this.pollStats();
        }, this.intervalLength);
      }, this.intervalLength);
    }
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  storeInitialStats() {
    const { campaign } = this.props;
    this.storeStats(campaign);
  }

  pollStats() {
    const { campaign } = this.props;

    fetchCampaignStats(campaign.id)
      .then((stats) => {
        this.storeStats(stats[0]);
      })
      .catch((err) => {
        console.error("Issue polling for campaign stats: ", err);
      });
  }

  storeStats(stats = {}) {
    this.setState({
      stats,
    });
  }

  render() {
    const { stats } = this.state;
    const { display_search, host, shrink, statType, currency_code } = this.props;

    const { statText, statNumber } = renderStatType(stats, statType);

    if ((stats && stats.id) || (stats && stats.campaign_id)) {
      return (
        <div
          className={
            shrink ? "giving-nav-total-container shrink" : "giving-nav-total-container"
          }>
          <div className="giving-nav-total-number--right">
            <div className="giving-nav-total total-amount">{statText}:&nbsp;</div>
            <div className="total-amount">
              <strong>{statNumber}</strong>
            </div>
          </div>
          <div className="giving-nav-total-number">
            <div className="giving-nav-total total-amount primary-color-text">
              total dollars:&nbsp;
            </div>
            <div className="total-amount primary-color-text">
              <FormattedNumber
                value={stats.amount_raised_including_family}
                style="currency"
                currencyDisplay="symbol"
                currency={currency_code}
                maximumFractionDigits={0}
              />
            </div>
          </div>
          {display_search && (
            <div style={{ float: "right" }}>
              <SearchForm host={host} />
            </div>
          )}
        </div>
      );
    }
    return null;
  }
}

const mapStateToProps = (state) => {
  const currentEntity = getEntity(state);

  return {
    currencySymbol: currentEntity.get("currency_symbol"),
  };
};

MenuBarStatsLive.propTypes = {
  campaign: PropTypes.object.isRequired,
  shrink: PropTypes.bool.isRequired,
  pollingInterval: PropTypes.number,
  statType: PropTypes.string,
  display_search: PropTypes.bool,
  host: PropTypes.string,
};

export default connect(mapStateToProps)(MenuBarStatsLive);
